import { gql } from "@apollo/client";

import { USER_FRAGMENT } from "./fragments";

export const GET_USERS = gql`
  ${USER_FRAGMENT}
  query GetUsers(
    $take: Int
    $skip: Int
    $filters: UserFilterInput
    $orderBy: [UserOrderByInput!]
  ) {
    users(take: $take, skip: $skip, filters: $filters, orderBy: $orderBy) {
      count
      nodes {
        ...User
      }
    }
  }
`;

export const GET_USER = gql`
  ${USER_FRAGMENT}
  query GetUser($id: Int!) {
    user(id: $id) {
      ...User
    }
  }
`;
